import{a as s}from"./chunk-QFTWB3KE.js";import{u as e,v as i}from"./chunk-G2ZQGRI3.js";import{m as n}from"./chunk-HBP5N4FR.js";n();i();var u=r=>{if(!r||typeof r!="string")return null;let t=r.split(e)[0];return s(t)?parseInt(t,10):null};export{u as a};
//# sourceMappingURL=chunk-77L2XBDZ.js.map
